import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const tenantSlug = localStorage.getItem('tenant_slug');
  if (tenantSlug) {
    config.headers['X-Tenant-ID'] = tenantSlug;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (path.startsWith('/super-admin')) {
        window.location.href = '/super-admin/login';
      } else {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Public
export const publicApi = {
  getPlans: () => api.get('/super-admin/plans'),
  registerSchool: (data) => api.post('/auth/register-school', data),
  getTenantInfo: (slug) => api.get(`/auth/tenant-info/${slug}`),
};

// Super Admin
export const superAdminApi = {
  init: (data) => api.post('/super-admin/init', data),
  login: (data) => api.post('/super-admin/login', data),
  getTenants: (includeInactive = true) => api.get('/super-admin/tenants', { params: { include_inactive: includeInactive } }),
  getPendingTenants: () => api.get('/super-admin/tenants/pending'),
  validateTenant: (id) => api.post(`/super-admin/tenants/${id}/validate`),
  suspendTenant: (id) => api.post(`/super-admin/tenants/${id}/suspend`),
  activateTenant: (id) => api.post(`/super-admin/tenants/${id}/activate`),
  deleteTenant: (id) => api.delete(`/super-admin/tenants/${id}`),
  changePlan: (tenantId, planId) => api.post(`/super-admin/tenants/${tenantId}/plan/${planId}`),
  getPlans: () => api.get('/super-admin/plans'),
  getStats: () => api.get('/super-admin/stats'),
};

// Tenant Auth
export const authApi = {
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// School Management (tenant-aware)
export const schoolApi = {
  getDashboard: () => api.get('/school/dashboard'),
  getStudents: (params) => api.get('/school/students', { params }),
  createStudent: (data) => api.post('/school/students', data),
  updateStudent: (id, data) => api.put(`/school/students/${id}`, data),
  deleteStudent: (id) => api.delete(`/school/students/${id}`),
  uploadStudentPhoto: (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/school/students/${id}/photo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  deleteStudentPhoto: (id) => api.delete(`/school/students/${id}/photo`),
  getTeachers: () => api.get('/school/teachers'),
  createTeacher: (data) => api.post('/school/teachers', data),
  deleteTeacher: (id) => api.delete(`/school/teachers/${id}`),
  getClasses: () => api.get('/school/classes'),
  createClass: (data) => api.post('/school/classes', data),
  deleteClass: (id) => api.delete(`/school/classes/${id}`),
  getUsers: () => api.get('/school/users'),
  createUser: (data) => api.post('/school/users', data),
  getEvaluations: (params) => api.get('/school/evaluations', { params }),
  createEvaluation: (data) => api.post('/school/evaluations', data),
  batchEvaluations: (data) => api.post('/school/evaluations/batch', data),
};

export default api;
